<div class="caption-bar">
  <div class="caption">{{ "files.title" | translate }}</div>
</div>
<lib-files></lib-files>
